
export default function FeatureCards() {
  return (
    <div className="overflow-hidden bg-gray-100 dark:bg-gray-800 dark:text-gray-100">
      <div className="container mx-auto px-4 py-16 lg:px-8 lg:py-32 xl:max-w-7xl">
        <div className="flex flex-col space-y-12 lg:flex-row lg:items-center lg:space-x-20 lg:space-y-0">
          {/* Heading */}
          <div className="space-y-10 md:py-12 lg:w-5/12 xl:w-5/12">
            <div>
              <div className="mb-1 text-sm font-bold uppercase tracking-wider text-primary-600 dark:text-primary-500">
                It’s time to build
              </div>
              <h2 className="mb-4 text-4xl font-black text-black dark:text-white">
                AI-Powered Solutions For Curbside Parking Management
              </h2>
              <h3 className="text-xl font-medium leading-relaxed text-gray-700 dark:text-gray-300">
                Embrace the future of curb management with Ai4Curb, the driving force behind innovation at JC-TECHS.
              </h3>
            </div>
          </div>
          {/* END Heading */}

          {/* Features in Cards */}
          <div className="relative flex-none lg:w-7/12 xl:w-7/12">
            <div className="bg-tranparent absolute left-0 top-0 -ml-12 -mt-5 size-40 rounded-full border border-orange-200 lg:size-72 dark:border-orange-900" />
            <div className="bg-tranparent absolute left-0 top-0 -ml-14 -mt-2 size-40 rounded-full border border-orange-100 lg:size-72 dark:border-orange-950" />
            <div className="bg-tranparent absolute bottom-0 right-0 -mb-5 -mr-12 size-40 rounded-full border border-purple-200 lg:size-72 dark:border-purple-900" />
            <div className="bg-tranparent absolute bottom-0 right-0 -mb-2 -mr-14 size-40 rounded-full border border-purple-100 lg:size-72 dark:border-purple-950" />
            <div className="relative flex flex-col space-y-6 md:flex-row md:space-x-6 md:space-y-0">
              <div className="space-y-6 md:mt-24 md:w-1/2">
                <div className="group rounded-2xl border border-gray-200 bg-white/25 p-6 backdrop-blur-sm transition duration-200 ease-out hover:border-orange-300 xl:p-8 dark:border-gray-700/75 dark:bg-gray-800/25 dark:hover:border-orange-700/75">
                  <div className="relative m-2 mb-6 inline-flex size-10 items-center justify-center">
                    <div className="absolute inset-0 -m-2 rotate-6 transform rounded-3xl bg-orange-300 transition duration-200 ease-out group-hover:-rotate-3 group-hover:scale-105" />
                    <div className="absolute inset-0 -rotate-6 transform rounded-2xl bg-orange-700 bg-opacity-75 shadow-inner transition duration-200 ease-out group-hover:rotate-2 group-hover:scale-105" />
                    <svg
                      className="hi-outline hi-adjustments-vertical relative inline-block size-6 text-white transition duration-200 ease-out group-hover:scale-110"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5"
                      />
                    </svg>
                  </div>
                  <h4 className="mb-2 text-lg font-bold">Zone and Sign Localization</h4>
                  <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                    Enables precise vehicle positioning through sensor data, facilitating accurate navigation and supporting applications for autonomous vehicles
                  </p>
                </div>
                <div className="group rounded-2xl border border-gray-200 bg-white/25 p-6 backdrop-blur-sm transition duration-200 ease-out hover:border-rose-300 xl:p-8 dark:border-gray-700/75 dark:bg-gray-800/25 dark:hover:border-rose-700/75">
                  <div className="relative m-2 mb-6 inline-flex size-10 items-center justify-center">
                    <div className="absolute inset-0 -m-2 rotate-6 transform rounded-3xl bg-rose-300 transition duration-200 ease-out group-hover:-rotate-3 group-hover:scale-105" />
                    <div className="absolute inset-0 -rotate-6 transform rounded-2xl bg-rose-700 bg-opacity-75 shadow-inner transition duration-200 ease-out group-hover:rotate-2 group-hover:scale-105" />
                    <svg
                      className="hi-outline hi-chart-pie relative inline-block size-6 text-white transition duration-200 ease-out group-hover:scale-110"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z"
                      />
                    </svg>
                  </div>
                  <h4 className="mb-2 text-lg font-bold">
                    Curbside Sign Reading
                  </h4>
                  <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                    Automatically interprets curbside signs using computer vision, enhancing navigation by providing real-time information on parking regulations
                  </p>
                </div>
              </div>
              <div className="space-y-6 md:w-1/2">
                <div className="group rounded-2xl border border-gray-200 bg-white/25 p-6 backdrop-blur-sm transition duration-200 ease-out hover:border-emerald-300 xl:p-8 dark:border-gray-700/75 dark:bg-gray-800/25 dark:hover:border-emerald-700/75">
                  <div className="relative m-2 mb-6 inline-flex size-10 items-center justify-center">
                    <div className="absolute inset-0 -m-2 rotate-6 transform rounded-3xl bg-emerald-300 transition duration-200 ease-out group-hover:-rotate-3 group-hover:scale-105" />
                    <div className="absolute inset-0 -rotate-6 transform rounded-2xl bg-emerald-700 bg-opacity-75 shadow-inner transition duration-200 ease-out group-hover:rotate-2 group-hover:scale-105" />
                    <svg
                      className="hi-outline hi-globe-alt relative inline-block size-6 text-white transition duration-200 ease-out group-hover:scale-110"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
                      />
                    </svg>
                  </div>
                  <h4 className="mb-2 text-lg font-bold">
                  Parked Car Detection
                  </h4>
                  <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                  Utilizes computer vision to identify stationary vehicles, optimizing parking space management and improving traffic flow

                  </p>
                </div>
                <div className="group rounded-2xl border border-gray-200 bg-white/25 p-6 backdrop-blur-sm transition duration-200 ease-out hover:border-purple-300 xl:p-8 dark:border-gray-700/75 dark:bg-gray-800/25 dark:hover:border-purple-700/75">
                  <div className="relative m-2 mb-6 inline-flex size-10 items-center justify-center">
                    <div className="absolute inset-0 -m-2 rotate-6 transform rounded-3xl bg-purple-300 transition duration-200 ease-out group-hover:-rotate-3 group-hover:scale-105" />
                    <div className="absolute inset-0 -rotate-6 transform rounded-2xl bg-purple-700 bg-opacity-75 shadow-inner transition duration-200 ease-out group-hover:rotate-2 group-hover:scale-105" />
                    <svg
                      className="hi-outline hi-puzzle-piece relative inline-block size-6 text-white transition duration-200 ease-out group-hover:scale-110"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 01-.657.643 48.39 48.39 0 01-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 01-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 00-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 01-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 00.657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 01-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 005.427-.63 48.05 48.05 0 00.582-4.717.532.532 0 00-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 00.658-.663 48.422 48.422 0 00-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 01-.61-.58v0z"
                      />
                    </svg>
                  </div>
                  <h4 className="mb-2 text-lg font-bold">
                  Curbside Navigation Algorithm
                  </h4>
                  <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                  Employs advanced algorithms to optimize navigation routes, specifically designed for curbside areas, enhancing efficiency in pick-up/delivery logistics, finding curbside parking zones that meet driver's needs, curbside parking sign maintenance; and reducing congestion

                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* END Features in Cards */}
        </div>
      </div>
    </div>
  );
}